export const LOGO_URL = "/images/iii-roma-logo.jpg";

export const PROFUMI_IMGS = {
  femme: "/profumi/femme-cameo.jpg",
  gems: "/profumi/femme-gems.jpg",
  homme: "/profumi/homme-gladiator.jpg",
  legionario: "/profumi/legionario.jpg",
  grid: "/profumi/femme-collection.jpg",
  hommeGrid: "/profumi/homme-collection.jpg",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/46cbd043-9f5a-40e2-9745-1c1a504fccd4/images/286e5e5ee5808a3d49a3fc47947979aa15c36c27b85b6aa46862b80658f6d79e.jpeg",
  story: "https://static.prod-images.emergentagent.com/jobs/46cbd043-9f5a-40e2-9745-1c1a504fccd4/images/03d03a88bb2a08090d950bbf1c2a5a01b4e69600770a860d98b18a1cd9e320af.jpeg",
  silk: "https://static.prod-images.emergentagent.com/jobs/46cbd043-9f5a-40e2-9745-1c1a504fccd4/images/79a41f9834b34c437fd052bdcaf33f9bd5fdcc15cc595bbd7054b304712b5036.jpeg",
  parchment: "/parchment.jpg",
};

export const FOUNDER_IMG = "/founder.jpg";

export const ENTRY_AUDIO = "/audio/imperium-aeternum.mp3";

export const FRANCHISE_IMGS = {
  facade: "/products/franchise-facade.jpg",
  bar: "/products/franchise-bar.jpg",
  bistrot: "/products/franchise-bistrot.jpg",
  kiosk: "/products/franchise-kiosk.jpg",
  lounge: "/products/franchise-lounge.jpg",
  terrace: "/products/franchise-terrace.jpg",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MARKETS = [
  { name: "Europa", native: "Europa" },
  { name: "United Kingdom", native: "United Kingdom" },
  { name: "United States", native: "United States" },
  { name: "Japan", native: "日本" },
  { name: "China", native: "中国" },
  { name: "Russia", native: "Россия" },
  { name: "Emirates", native: "الإمارات" },
  { name: "Brazil", native: "Brasil" },
  { name: "Turkey", native: "Türkiye" },
  { name: "South Korea", native: "대한민국" },
  { name: "Malaysia", native: "Malaysia" },
  { name: "Australia", native: "Australia" },
  { name: "Singapore", native: "Singapore" },
];
